var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13C26 5.81953 20.1805 0 13 0C5.81953 0 0 5.81953 0 13C0 19.4898 4.75312 24.8676 10.9688 25.8426V16.7578H7.66797V13H10.9688V10.1359C10.9688 6.87832 12.9086 5.07812 15.8793 5.07812C17.3012 5.07812 18.7891 5.33203 18.7891 5.33203V8.53125H17.1488C15.534 8.53125 15.0312 9.53418 15.0312 10.5625V13H18.6367L18.0604 16.7578H15.0312V25.8426C21.2469 24.8676 26 19.4898 26 13Z",
    fill: "#A0A6C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.83c578ca0c7a149cabd6e6a70cddc029.svg";
export { ForwardRef as ReactComponent };